<template>
	<div class="Slideshow" :class="{ activeSlideshow: slideshowActive }">

		<div @click="closeSlideshow" class="Slideshow__exit">
			<p>&#10005;</p>
		</div>

		<div class="Slideshow__featuredImage">

			<div  @click="setPreviousImage" class="Slideshow__featuredImage__previous">
				<span>&#10094;</span>
			</div>

			<div class="Slideshow__featuredImage__image">
				<img :src="currentImage">
			</div>

			<div @click="setNextImage" class="Slideshow__featuredImage__next">
				<span>&#10095;</span>
			</div>

		</div>

		<div class="Slideshow__thumbnails" :class="{ thumbnailsVisible: thumbnailsVisible }">

			<div @click="toggleThumbnails" class="Slideshow__thumbnails__topBar">
				<Arrow class="icon" />
				<p>{{ $t('GalleryPointerSlike') }}</p>
			</div>
			<div class="Slideshow__thumbnails__container">
				<div class="Slideshow__thumbnails__container__body">
					<div 
						v-for="(image, index) in images" 
						:key="index" @click="setCurrentIndex(index)"
						:class="{ activeThumbnail: currentIndex === index }"
					>
						<img :src="image">
					</div>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
import Arrow from 'vue-material-design-icons/ArrowUpDropCircle'

export default {
	name: 'Slideshow',
	components: {
		Arrow
	},
	props: {
		images: {
			type: Array,
			default: () => []
		}
	},
	data() {
		return {
			slideshowActive: false,
			currentIndex: 0,
			thumbnailsVisible: false
		}
	},
	computed: {
		currentImage() {
			return this.getCurrentImage(this.images, this.currentIndex)
		}
	},
	watch: {
		// slideshowActive() {
		// 	document.body.style.overflow = this.slideshowActive ? 'hidden !important' : ''
		// },
		images: {
			handler(newVal, oldVal) {
				if(newVal.length > 0) {
					this.slideshowActive = true
				} else if(newVal.length === 0) {
					this.slideshowActive = false
				}
			},
			deep: true
		}
	},
	methods: {
		getCurrentImage(images, currentIndex) {
			const selectedImage = images.filter((image, index) => index === currentIndex).join('')
			return selectedImage
		},
		setCurrentIndex(index) {
			this.currentIndex = index
		},
		setPreviousImage() {
			if(this.currentIndex > this.images.length - this.images.length) {
				this.currentIndex--
			}
		},
		setNextImage() {
			if(this.currentIndex < this.images.length - 1) {
				this.currentIndex++
			}
		},
		closeSlideshow() {
			this.currentIndex = 0
			this.$emit('close')
		},
		toggleThumbnails() {
			this.thumbnailsVisible = !this.thumbnailsVisible
		}
	}
}
</script>

<style lang="scss" scoped>

.Slideshow {
	@include transition(0.2);
	z-index: 5;
	position: fixed;
	opacity: 0;
	visibility: hidden;
	display: flex;
	align-items: center;
	justify-content: center;

	&__exit {
		cursor: pointer;
		position: absolute;
		top: 10px;
		right: 10px;
		display: flex;
		justify-content: flex-end;

		@media screen and (min-width: 1440px) {
			right: 20px;
		}

		p {
			margin: 0;
			color: $grey;
			font-size: 2em;
		}
	}

	&__featuredImage {
		margin-top: -80px;
		width: 100%;
		height: 300px;
		display: flex;
		justify-content: center;
		align-items: center;
		position: relative;
		@include transition(0.2);

		@media screen and (min-width: 1024px) {
			margin-top: -50px;
		}

		&__previous, &__next {
			position: absolute;
			top: 0;
			bottom: 0;
			width: 50px;
			height: 100%;
			display: flex;
			justify-content: center;
			align-items: center;
			cursor: pointer;
			@include transition(0.1);

			@media screen and (min-width: 1024px) {
				&:hover {
					background: rgba(104, 104, 104, 0.1);
				}
			}

			span {
				margin: 0;
				color: $grey;
				font-size: 2em;
				cursor: pointer;
			}
		}
		&__previous {
			left: 0;
		}
		&__next {
			right: 0;
		}

		&__image {
			width: 100%;
			height: 300px;
			margin: 0 auto;
			text-align: center;
			@include transition(0.2);

			@media screen and (min-width: 1024px) {
				height: 500px;
			}
			@media screen and (min-width: 2000px) {
				height: 1000px;
			}

			img {
				width: 90%;
				height: 100%;
				object-fit: scale-down;
				background-size: cover;
				background-position: center;
				@include transition(0.2);
			}
		}
	}

	&__thumbnails {
		@include transition(0.2);
		background: lighten(#273940, 10);
		height: calc(0% + 40px);
		position: absolute;
		bottom: 0;
		left: 0;
		right: 0;

		&__topBar {
			height: 40px;
			display: flex;
			justify-content: center;
			align-items: center;
			border-bottom: 1px solid rgba(255, 255, 255, 0.3);
			background: $blue;
			cursor: pointer;

			.icon {
				font-size: 1.5em;
				margin-right: 10px;
				margin-top: -5px;
				color: white;
			}

			p {
				color: white;
				margin: 0;
			}
		}

		&__container {
			padding: 20px;
			height: calc(100% - 40px);

			&__body {
				height: 100%;
				overflow-y: auto;
				display: grid;
				grid-template-columns: repeat(2, 1fr);
				grid-template-rows: repeat(10, minmax(180px, 200px));
				grid-gap: 20px;

				@media screen and (min-width: 768px) {
					grid-template-columns: repeat(3, 1fr);
				}
				@media screen and (min-width: 1440px) {
					grid-template-columns: repeat(4, 1fr);
				}
				@media screen and (min-width: 2000px) {
					grid-template-columns: repeat(5, 1fr);
				}

				div {
					background: rgba(0, 0, 0, 0.4);
					border-radius: 5px;
					padding: 3px;
					display: flex;
					justify-content: center;
					align-items: center;
					cursor: pointer;

					img {
						width: 100%;
						height: 100%;
						object-fit: scale-down;
						background-size: cover;
						background-position: center;
						border-radius: 5px;
					}
				}
			}
		}
	}

}

.activeSlideshow {
	top: 80px;
	left: 0;
	right: 0;
	bottom: 0;
	background: white;
	opacity: 1;
	visibility: visible;
	@include transition(0.2);
}

.thumbnailsVisible {
	height: 100%;

	@media screen and (min-width: 768px) {
		height: 60%;
	}

	.Slideshow__thumbnails__topBar {

		.icon {
			transform: rotate(180deg);
			margin-bottom: -10px;
		}
	}
	.activeThumbnail {
		border: 2px solid $blue;
	}
}

.activeThumbnail {
	border: 1px solid $blue;
}
</style>
